export default "__VITE_ASSET__c7d7d501__"